import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useFlexNotificationUrl } from "../api";

const FlexRedirect = () => {
  const [params] = useSearchParams();
  const domain = params.get("domain");
  const itemId = params.get("itemId");
  const { data: url } = useFlexNotificationUrl({
    domain,
    itemId: Number(itemId),
  });
  const nav = useNavigate();
  useEffect(() => {
    if (url === null || url == undefined) return;
    if (url) {
      nav(url);
    } else {
      nav("/404");
    }
  }, [url]);
  return <div></div>;
};
export default FlexRedirect;
